import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from './constants'

export const apiSlice = createApi({
    reducerPath: 'api', // optional
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    tagTypes: ['Services', 'Products', 'Blogs', 'HomePages', 'AboutPages', 'ImageGallerys', 'Appointments', 'Contacts'],
    endpoints: builder => ({})
})